import { ChartUiState, ChartUiMutation } from './types'
import { MutationTree } from 'vuex'
import { PeriodType } from '@ecocoach/domain-store-modules/src/chart/models'

export const mutations: MutationTree<ChartUiState> = {
  [ChartUiMutation.setLoading](state, isLoading: boolean) {
    state.isLoading = isLoading
  },
  [ChartUiMutation.setSelectedChartCollectionId](state, chartCollectionId: string) {
    state.selectedChartCollectionId = chartCollectionId
  },
  [ChartUiMutation.setSelectedChartId](state, chartId: string) {
    state.selectedChartId = chartId
  },
  [ChartUiMutation.setSelectedChartPeriod](state, chartPeriod: PeriodType) {
    state.selectedChartPeriod = chartPeriod
  },
  [ChartUiMutation.setSelectedNodeId](state, nodeId: string | null) {
    state.selectedNodeId = nodeId
  },
  [ChartUiMutation.setScaleSelected](state, scaleSelected: boolean) {
    state.scaleSelected = scaleSelected
  },
  [ChartUiMutation.setSelectedChartPeriodStartDateTime](state, chartPeriodStartDateTime: string) {
    state.selectedChartPeriodStartDateTime = chartPeriodStartDateTime
  },
  [ChartUiMutation.setSeriesHidden](state, { id, hidden }: { id: string, hidden: boolean }) {
    const keys = new Set(state.hiddenSeriesKeys)
    if (hidden) {
      keys.add(id)
    } else {
      keys.delete(id)
    }
    state.hiddenSeriesKeys = Array.from(keys)
  },
  [ChartUiMutation.setHiddenSeriesKeys](state, seriesKeys: string[]) {
    state.hiddenSeriesKeys = seriesKeys
  },
  [ChartUiMutation.setDateTimeUtcNow](state, dateTime: string) {
    state.dateTimeUtcNow = dateTime
  },
}
